import { useEffect, useState, useCallback } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Loader2 } from "lucide-react";
import Dashboard from "./pages/Dashboard";
import ProjectView from "./pages/ProjectView";
import SharedView from "./pages/SharedView";
import AdminPanel from "./pages/AdminPanel";
import AdminDashboard from "./pages/AdminDashboard";
import AuthCallback from "./pages/AuthCallback";
import SlideshowView from "./pages/SlideshowView";
import Library from "./pages/Library";
import { AuthProvider } from "./contexts/AuthContext";
import SiteGate from "./components/SiteGate";
import { getRegistrationStatus } from "./lib/api";

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<Dashboard />} />
      <Route path="/project/:id" element={<ProjectView />} />
      <Route path="/project/:id/slideshow" element={<SlideshowView />} />
      <Route path="/shared/:token" element={<SharedView />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/admin" element={<AdminPanel />} />
      <Route path="/admin/users" element={<AdminDashboard />} />
      <Route path="/library" element={<Library />} />
    </Routes>
  );
}

function App() {
  const [gateChecked, setGateChecked] = useState(false);
  const [gateRequired, setGateRequired] = useState(false);

  useEffect(() => {
    document.documentElement.classList.add("dark");
  }, []);

  const checkGate = useCallback(async () => {
    try {
      const s = await getRegistrationStatus();
      setGateRequired(!!s?.enabled && !s?.passed);
    } catch {
      // If the status check fails, fail open (don't block) - admin can fix server-side.
      setGateRequired(false);
    } finally {
      setGateChecked(true);
    }
  }, []);

  useEffect(() => { checkGate(); }, [checkGate]);

  if (!gateChecked) {
    return (
      <div className="flex h-screen items-center justify-center bg-background">
        <Loader2 className="w-5 h-5 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (gateRequired) {
    return (
      <>
        <Toaster richColors position="top-center" />
        <SiteGate onPassed={() => setGateRequired(false)} />
      </>
    );
  }

  return (
    <AuthProvider>
      <Router>
        <Toaster richColors position="top-center" />
        <AppRouter />
      </Router>
    </AuthProvider>
  );
}

export default App;
